<div class="mat-body confirm-dialog">
  <h1 mat-dialog-title>{{data.titleKey| translate: [data.titleKey , translationService.language]}}</h1>

  <mat-dialog-content>
    <div [innerHTML]="data.messageKey| translate: getMessageArgs() | trustHtml"></div>
  </mat-dialog-content>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex >
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button (click)="cancel()">{{'no' | translate: ['shared.confirm-dialog.action.no',
      translationService.language]}}</button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="confirm()">
      <ng-container *ngIf="data.confirmBtnKey != null">
        {{'yes' | translate: [data.confirmBtnKey, translationService.language]}}
      </ng-container>
      <ng-container *ngIf="data.confirmBtnKey == null">
        {{'yes' | translate: ['shared.confirm-dialog.action.yes', translationService.language]}}
      </ng-container>
    </button>
  </sc-flex>

</div>
